import { Link } from 'react-router-dom';
import { ROUTES } from '@/routes';
import { useAuthStore } from '@/store/auth';

export const APP_NAME = 'Tally';

/** A tally mark: four strokes and the fifth across them. */
export function TallyMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
      <g stroke="currentColor" strokeWidth="2.6" strokeLinecap="round">
        <path d="M9 8v16M13.5 8v16M18 8v16M22.5 8v16" />
        <path d="M5.5 21.5 26 10.5" opacity="0.75" />
      </g>
    </svg>
  );
}

export function Logo({ size = 'md', linkTo }: { size?: 'sm' | 'md' | 'lg'; linkTo?: string }) {
  const { isAuthenticated } = useAuthStore();
  const destination = linkTo ?? (isAuthenticated ? ROUTES.app.dashboard : ROUTES.home);
  const sizes = { sm: 'h-7 w-7', md: 'h-9 w-9', lg: 'h-11 w-11' };
  const textSizes = { sm: 'text-lg', md: 'text-xl', lg: 'text-2xl' };

  return (
    <Link to={destination} className="flex items-center gap-2" aria-label={`${APP_NAME} home`}>
      <div className={`${sizes[size]} flex items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-sm`}>
        <TallyMark className="h-[70%] w-[70%]" />
      </div>
      <span className={`${textSizes[size]} font-bold tracking-tight`}>{APP_NAME}</span>
    </Link>
  );
}
